import { useParams } from 'react-router-dom';
import useWorkflowVersions from '@/hooks/workflows/useWorkflowVersions';
import { BreadcrumbPage } from '@/components/ui/breadcrumb';
import { Badge } from '@/components/ui/badge';
import { RenderIf } from '@/components/RenderIf';
import { VersionCrumbProps } from './types';
import shortVersion from './helpers/shortVersion';

const VersionCrumb = ({ param, showBadge = false }: VersionCrumbProps) => {
    const params = useParams();
    const versionId = params[param];

    const { versions, isLoadingVersions } = useWorkflowVersions();

    // Display short version ID
    const label = shortVersion(versionId || '');

    // Find badge info
    let badge;
    if (showBadge && !isLoadingVersions) {
        const currentVersion = versions.find(version => version.id === versionId);

        if (currentVersion?.tags.includes('published')) {
            badge = { text: 'Published', variant: 'default' as const };
        } else if (currentVersion?.tags.includes('draft')) {
            badge = { text: 'Draft', variant: 'secondary' as const };
        }
    }

    return (
        <BreadcrumbPage>
            <div className="flex items-center gap-2">
                {label}
                <RenderIf isTrue={!!badge}>
                    <Badge variant={badge?.variant}>{badge?.text}</Badge>
                </RenderIf>
            </div>
        </BreadcrumbPage>
    );
};

export default VersionCrumb;
